import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { DocumentTemplateFileFetchFailedAction } from '@Application/Beneficiaries/Documents/Actions/documentTemplateFileFetchFailed';
import type { DocumentTemplateFileFetchedAction } from '@Application/Beneficiaries/Documents/Actions/documentTemplateFileFetched';
import DocumentTemplateFileView from '@UI/Store/DocumentTemplateFiles/Views/DocumentTemplateFileView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type DocumentTemplateFilesStore = {
	file: DocumentTemplateFileView | null;
};

const initialState: DocumentTemplateFilesStore = {
	file: null,
};

type Actions = DocumentTemplateFileFetchedAction | DocumentTemplateFileFetchFailedAction | UserRevokedAction;

const whenDocumentTemplateFileFetched = (
	_store: DocumentTemplateFilesStore,
	action: DocumentTemplateFileFetchedAction,
): DocumentTemplateFilesStore => ({
	file: new DocumentTemplateFileView(action.payload.templateVersionId, action.payload.bytes),
});

const whenUserRevoked = (): DocumentTemplateFilesStore => initialState;

// The error is already carried by `useStoreQuery`'s own `error` field.
const identity = (store: DocumentTemplateFilesStore): DocumentTemplateFilesStore => store;

export default registerStore<'documentTemplateFilesStore', Actions>(
	'documentTemplateFilesStore',
	createSliceReducer({
		DOCUMENT_TEMPLATE_FILE_FETCHED: whenDocumentTemplateFileFetched,
		DOCUMENT_TEMPLATE_FILE_FETCH_FAILED: identity,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
